import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {webServiceConfig} from '../config/web-service.config';
import {map} from 'rxjs/operators';
import {DataTablesResponse} from '../models/dataTables-response';

@Injectable({
    providedIn: 'root'
})
export class CategoryService {

    constructor(private http: HttpClient) {
    }

    getDatatable(dataTablesParameters): Observable<any> {
        return this.http.post<DataTablesResponse>(`${webServiceConfig.webServiceUrl}categories/datatable`, dataTablesParameters, {})
            .pipe(map(response => {
                return response;
            }));
    }

    getAll(status: any = ''): Observable<any> {
        if (status) {
            status = `?status=${status}`;
        }
        return this.http.get(`${webServiceConfig.webServiceUrl}categories${status}`).pipe(map(response => {
            return response;
        }));
    }

    getById(categoryId: number): Observable<any> {
        return this.http.get(`${webServiceConfig.webServiceUrl}categories/${categoryId}`).pipe(map(response => {
            return response;
        }));
    }

    store(category: any): Observable<any> {
        return this.http.post(`${webServiceConfig.webServiceUrl}categories`, category)
            .pipe(map(response => {
                return response;
            }));
    }

    update(category: any): Observable<any> {
        return this.http.put(`${webServiceConfig.webServiceUrl}categories/${category.id}`, category)
            .pipe(map(response => {
                return response;
            }));
    }

    delete(id: number): Observable<any> {
        return this.http.delete(`${webServiceConfig.webServiceUrl}categories/${id}`)
            .pipe(map(response => {
                return response;
            }));
    }
}
